import { FC } from 'react';
import { Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import { useCurrentUserId } from 'modules/Auth/hooks';
import { PlaygroundConfig } from 'modules/Playground/types/playgroundConfig';
import { PlaygroundContainer } from 'modules/Playground/Components/PlaygroundContainer';
import { breakpoints } from 'styles/utils';
import { ApiSingleModelResponse, ApiMultiModelResponse } from 'types/swagger/clarifai-api';
import { splitByLastDoubleUnderscore } from 'modules/WorkflowV2/utils/splitByLastDoubleUnderscore';
import { useFeaturedModels } from './api/hooks/useFeaturedModels';
import { useGetModel } from './api/hooks/useGetModel';

export const Playground: FC<{
  featuredModelInitialData: ApiMultiModelResponse;
  selectedModelInfo?: ApiSingleModelResponse;
  query: {
    model?: string;
    user_id?: string;
    app_id?: string;
  };
}> = observer(({ featuredModelInitialData, selectedModelInfo, query }) => {
  const currentUserId = useCurrentUserId();

  // Hydrate the featured models from the server
  useFeaturedModels(featuredModelInitialData);

  const modelQuery = query.model as string | undefined;
  const userId = query.user_id as string | undefined;
  const appId = query.app_id as string | undefined;

  const [modelId, modelVersionId] = splitByLastDoubleUnderscore(modelQuery);

  const { data: selectedModel } = useGetModel(
    {
      params: {
        userAppIdUserId: userId,
        userAppIdAppId: appId,
        modelId,
      },
      query: {
        version_id: modelVersionId,
      },
    },
    selectedModelInfo,
  );

  const handleFormSubmit = () => {
    // HACK: No-op, formik is used only for keeping the state of the playground
  };

  const baseInitialValues: PlaygroundConfig = {
    type: 'chat' as const,
    fieldValueMap: {},
    trainingTemplateFields: [],
    model: selectedModel?.model,
  };

  return (
    <>
      {/* TODO: Remove key when we have a better solution for resetting form state */}
      <Formik<PlaygroundConfig> key={currentUserId} onSubmit={handleFormSubmit} initialValues={baseInitialValues} enableReinitialize>
        <PlaygroundContainer />
      </Formik>

      <style>
        {/* Hide Intercom and Recaptcha widgets on mobile view (only in playground) */}
        {`
          .intercom-lightweight-app {
            ${breakpoints.down('mdpi')} {
              display: none !important;
            }
          }
          .rc-anchor {
            ${breakpoints.down('mdpi')} {
              display: none !important;
            }
          }
        `}
      </style>
    </>
  );
});
